import { useState } from 'react';
import { MainAdminLayout } from 'admin/layout/MainAdminLayout';
import { OfferTopBlock } from 'admin/components/Offer/OfferTopBlock';
import { OfferSection } from 'admin/components/Offer/OfferSection';
import { OFFER_DATA, TemplateOptions } from 'admin/TableDatas/OfferDatas';

export const AdminOffer = () => {
  const [tableOptions, setTableOptions] = useState(TemplateOptions);
  const [offerData, setOfferData] = useState(OFFER_DATA);

  return (
    <MainAdminLayout>
      <OfferTopBlock
        OFFER_DATA={OFFER_DATA}
        setOfferData={setOfferData}
        setTableOptions={setTableOptions}
        tableOptions={tableOptions}
      />
      <OfferSection
        OFFER_DATA={OFFER_DATA}
        offerData={offerData}
        setOfferData={setOfferData}
        setTableOptions={setTableOptions}
      />
    </MainAdminLayout>
  );
};
